"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AuthorizationStore_1 = __importDefault(require("../../stores/AuthorizationStore"));
const cache = __FETCH_CACHE_MAP__;
const cachedFetchApi = (requestInfo, init) => {
    const fallback = () => fetch(requestInfo, init);
    if (typeof requestInfo !== 'string' ||
        AuthorizationStore_1.default.auth0?.isLoading !== false ||
        AuthorizationStore_1.default.auth0?.isAuthenticated !== false) {
        return fallback();
    }
    //The BE generator uses 0/1 and the FE generator uses true/false. We need to transform the URLs to map the caches.
    const url = new URL(requestInfo);
    url.searchParams.forEach((value, key) => {
        switch (value) {
            case 'true':
                url.searchParams.set(key, '1');
                break;
            case 'false':
                url.searchParams.set(key, '0');
                break;
        }
    });
    const cacheKey = url.toString();
    if (Object.keys(cache).includes(cacheKey)) {
        const { body, ...meta } = cache[cacheKey];
        const response = new Response(body, meta);
        return Promise.resolve(response);
    }
    return fallback();
};
exports.default = cachedFetchApi;
